import { getApi } from "./api_instance";

export const notifications = async (logout) => {
  try {
    return await getApi({
      apiUrl: "/admin/projects/api/notification",
      sendToken: true,
      logout,
    });
  } catch (error) {
    throw error;
  }
};
